/**
* @file 运营中心-平台审核-司机审核
* */
<template>
  <div id="driverAudit">
    <custom-table excel-type="ReferrerFlowing" ref="customTable" has-organization="true" :customOptions="customOptions"
                  :columns="columns">
      <template slot="search-bottom">
        <span class="util-remark"> 结算时请确认出资账户余额充足，若因出资账户余额不足导致的转账失败可重新发起转账</span>
      </template>
      <template slot="search-button-right">
        <el-button type="primary" @click="actionFn({ type: 'examine'})">审核设置</el-button>
      </template>
      <template slot="customTable-top">
        <el-radio-group v-model="status" @change="statusChange" style="padding-bottom: 16px;">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button :label="item.value" v-for="item in $const.SETTLEMENTSTATUS" :key="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="128px">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text" v-if="row.status == 1" @click="examineFn(row)">审核</el-button>
            <el-button type="text" v-if="row.transferStatus == 3" @click="transferFailFn(row)">
              重新转账

            </el-button>

          </div>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'created'">{{ row.created | filterTime }}</template>
        <template v-else-if="item.prop === 'auditTime'">{{ row.auditTime | filterTime }}</template>
        <template v-else-if="item.prop === 'transferStatus'">{{
            row.transferStatus | filterConst('TRANSFERFAILREASON')
          }}
          <el-tooltip v-if="row.transferStatus === 3" class="item" effect="dark" :content="row.transferFailReason"
                      placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template v-else-if="item.prop === 'status'">{{ row.status === 1 ? '待审核' : '已通过' }}</template>
        <template v-else-if="item.prop === 'amount'"><span class="util-money">¥{{ row.amount }}</span></template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>
    </custom-table>


    <el-dialog :visible.sync="showExamine" destroy-on-close title="审核设置" width="600px"
               :before-close="()=>(showExamine = false)">
      <examineSetting @handClose="showExamine = false" v-if="showExamine"></examineSetting>
    </el-dialog>

  </div>
</template>

<script>
import examineSetting from './components/examineSetting.vue'

export default {
  name: "driverAudit",
  components: {
    examineSetting
  },

  data() {
    return {
      status: '',
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/referrer/flowing/settle',
        params: {
          status: '',
          page: 1, // 页数
          size: 20 // 每页条数
        },
        search: [
          {type: 'input', field: 'adminName', name: '申请人', value: ''},
          {type: 'input', field: 'adminPhone', name: '手机号码', value: ''},
          {type: "datetime", field: "time", name: "申请时间", value: []},
        ]
      },
      // 表头
      columns: [
        {prop: 'adminName', label: '申请人'},
        {prop: 'adminPhone', label: '手机号'},
        {prop: 'amount', label: '申请结算金额'},
        {prop: 'created', label: '申请时间'},
        {prop: 'auditTime', label: '审核时间'},
        {prop: 'status', label: '审核状态'},
        {prop: 'transferStatus', label: '转账状态'}
      ],
      showExamine: false
    }
  },
  created() {

  },
  methods: {
    actionFn({type}) {
      switch (type) {
        case 'examine':
          this.showExamine = true
          break;
      }

    },
    examineFn(row) {

      this.$confirm("是否确认通过结算审核？", "结算审核").then(async () => {
        let url = '/api/v1/manage/referrer/flowing/settle'
        let data = await this.$axios.post(url, {id: row.id})
        if (data && data.code == 1) {
          this.$message.success('操作成功')
          this.$refs.customTable.listFn()
        }
      });
    },
    transferFailFn(row) {
      this.$confirm("是否确认重新转账？", "重新转账").then(async () => {
        let url = '/api/v1/manage/referrer/flowing/settle/transfer'
        let data = await this.$axios.post(url, {id: row.id})
        if (data && data.code == 1) {
          this.$message.success('操作成功')
          this.$refs.customTable.listFn()
        }
      });
    },
    statusChange() {
      this.customOptions.params.page = 1
      this.customOptions.params.status = this.status;
      this.$refs.customTable.listFn();
    },
  }
}
</script>

<style lang="less">
#driverAudit {
  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 10px;

    .el-select {
      width: 100%;

      .el-input {
        width: 100%;
      }
    }
  }

  .img-group {
    display: flex;
    flex-wrap: wrap;

    .img-group-item {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-bottom: 30px;

      p {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;
      }

      img {
        width: 120px;
        height: 80px;
      }

      .no-upload {
        border: 1px #ebebeb dashed;
        width: 120px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #999;
      }
    }
  }
}
</style>
